<div class="d-flex align-items-center">
  <mat-form-field appearance="full" class="flex-grow-1 mr-2" style="min-width: 0;">
    <mat-label *ngIf="title">{{title}}</mat-label>
    <mat-chip-list #chipList>
      <mat-chip *ngFor="let option of selectedOptions" [removable]="true" (removed)="remove(option)">
        {{ option.text }}
        <mat-icon matChipRemove>cancel</mat-icon>
      </mat-chip>
      <input matInput [formControl]="control" [matAutocomplete]="auto" [matChipInputFor]="chipList"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes" placeholder="{{placeHolder}}" #inputElement>
    </mat-chip-list>
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="select($event)">
      <mat-option *ngFor="let option of filteredOptions | async" [value]="option.value"
        [disabled]="isSelected(option)">
        {{ option.text }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <!-- 按鈕上下排、依內容定寬，搜尋框吃剩餘寬度 -->
  <div class="d-flex flex-column flex-shrink-0">
    <button type="button" class="vis-btn-config p-0 position-relative pl-2 w-24 mb-2" (click)="selectAll()" title="選擇全部">
      <mat-icon class="pref-icon vis-combine-icon">check_box</mat-icon>
      <span class="position-absolute text-xs-sm start-0 ml-4 pl-2">選擇全部</span>
    </button>
    <button type="button" class="vis-btn-config p-0 position-relative pl-2 w-24" (click)="clearAll()" title="清除全部">
      <mat-icon class="pref-icon remove vis-combine-icon">remove_circle</mat-icon>
      <span class="position-absolute text-xs-sm start-0 ml-4 pl-2">清除全部</span>
    </button>
  </div>
</div>
